import {PermissionType} from '@hconnect/apiclient'
import {useUpmPlantsContext, getPlantName} from '@hconnect/upm'
import {usePlantsByPermission} from '@hproduce/permissions'

import {TaskSource} from '../types'

const permissionByTaskType: Record<TaskSource, PermissionType> = {
  [TaskSource.PROCESS_WORK_ORDER]: 'CREATE_PROCESS_WORK_ORDER',
  [TaskSource.COCKPIT]: 'CREATE_PLANT_EVENT',
  [TaskSource.EASY_POM]: 'CHANGE_POM_DASHBOARD',
  [TaskSource.MACHINE_SENTRY_ACTIONS]: 'CREATE_PLANT_EVENT',
  [TaskSource.OIL_ANALYSIS_ACTIONS]: 'CREATE_PLANT_EVENT',
  [TaskSource.DALOG_ACTIONS]: 'CREATE_PLANT_EVENT'
} as const

export const useTaskPlantsOptions = (taskType: TaskSource) => {
  const {plantIds} = usePlantsByPermission(permissionByTaskType[taskType])
  const upmPlants = useUpmPlantsContext()
  const options = plantIds.map((plantId) => ({
    value: plantId,
    label: getPlantName(upmPlants, plantId)
  }))
  return options
}

export const useTaskUpmPlantsOptions = (taskType: TaskSource) => {
  const {plantIds: permissionPlantIds} = usePlantsByPermission(permissionByTaskType[taskType])
  const upmPlants = useUpmPlantsContext()
  const filteredPlantIds = Object.values(upmPlants).filter(({plantId}) =>
    permissionPlantIds.includes(plantId)
  )
  const options = filteredPlantIds.map(({upmId, name}) => ({
    value: upmId,
    label: name
  }))
  return options
}
